import { observable, makeObservable } from 'mobx';
import Celebration from './Celebration';

class Anniversary extends Celebration {
  numberOfYears;

  constructor(other) {
    super();

    makeObservable(this, {
      numberOfYears: observable
    });

    this.merge(other);
  }
}

export default Anniversary;
